const defaultTheme = {
  colors: {
    'background': '#111111',
    'text': '#ffffff',
  },
  fonts: {
    // eslint-disable-next-line quotes
    'family': `'Akzidenz Grotesk Pro', sans-serif`,
    // eslint-disable-next-line quotes
    'familyCode': `'Courier New', monospace`,
    'size': 16,
    'lineHeight': 24 / 16,
    'headersize': 20,
    'headerLineHeight': 24 / 20
  }
}

const themeProject = {
  colors: {
    'background': '#111111',
    'white_5': '#ffffff80',
    'grey': '#262626',
    'text': '#FFFFFF',
    'white': '#FFFFFF',
    'black': '#111111',
    'input_error': '#FF3945',
  },
  fonts: {
    primaryFont: 'sans-serif'
  }
}

export const theme = {
  colors: {
    ...defaultTheme.colors,
    ...themeProject.colors
  },
  fonts: {
    ...defaultTheme.fonts,
    ...themeProject.fonts
  }
}

